import LanguageDetector from 'i18next-browser-languagedetector';
import i18next, { CustomTypeOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';
import * as formatters from './formatters';
import routes_en from './en/routes.json';
import routes_ro from './ro/routes.json';
import common_en from './en/common.json';
import common_ro from './ro/common.json';
import pages_en from './en/pages.json';
import pages_ro from './ro/pages.json';
import api_en from './en/api.json';
import api_ro from './ro/api.json';

// Configure the namespaces and load all locs
const fallbackLang = 'ro';
export const SUPPORTED_LANGUAGES = ['ro', 'en'] as const;
export type SupportedLanguages = typeof SUPPORTED_LANGUAGES[number];
export const defaultNS: CustomTypeOptions["defaultNS"] = "translations";
export const resources: { [key: string]: CustomTypeOptions["resources"] } = {
    en: {
        routes: routes_en,
        common: common_en,
        pages: pages_en,
        api: api_en,
    },
    ro: {
        routes: routes_ro,
        common: common_ro,
        pages: pages_ro,
        api: api_ro,
    },
} as const;

// Set the initial language for the user
if (localStorage.getItem('language') === null) {
    localStorage.setItem('language', fallbackLang);
}

// TODO: solve the case when the user uses a link not localized for him
// and it should redirect him to the other variant
// Configure the library
i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources,
        defaultNS,
        fallbackLng: fallbackLang,
        ns: [
            'common',
            'routes',
            'pages',
        ],
        detection: {
            caches: ['localStorage'],
            lookupLocalStorage: 'language',
            order: ['path', 'localStorage', 'navigator', 'htmlTag'],
            htmlTag: document.documentElement,
        }
    }); // TODO: error handling
        // TODO: consider backend plugin

// Add custom formatters for ease of usage
i18next.services.formatter?.add(...formatters.upperCaseFormatter);
i18next.services.formatter?.add(...formatters.lowerCaseFormatter);

// Re-detect the language and change the HTML tag
i18next
    .changeLanguage()
    .then(() => {
        document.documentElement.lang = i18next.language;
        window.localStorage.setItem('language', i18next.language);
    });

export default i18next;